import { FaReact, FaNodeJs, FaJava, FaPython, FaGitAlt } from 'react-icons/fa';
import { SiTypescript, SiNextdotjs, SiPostgresql, SiSupabase, SiFigma, SiSpringboot, SiDotnet } from 'react-icons/si';
import './Skills.css';
const skills = [
  [FaReact, 'React'], [SiNextdotjs, 'Next.js'], [SiTypescript, 'TypeScript'],
  [FaNodeJs, 'Node.js'], [SiPostgresql, 'PostgreSQL'], [SiSupabase, 'Supabase'],
  [FaJava, 'Java'], [SiSpringboot, 'Spring Boot'], [FaPython, 'Python'],
  [SiDotnet, '.NET'], [FaGitAlt, 'Git'], [SiFigma, 'Figma'],
];
export default function Skills() {
  return <ul className="skills-grid" aria-label="Development and design tools">{skills.map(([Icon, name]) => <li key={name}><Icon aria-hidden="true" /><span>{name}</span></li>)}</ul>;
}
